/**
 * 사용자 관련 API 모음
 */
/* API 주소 */
import apiClient from '../axios';

const USER_URL = () => '/api/user';
const USER_DASHBOARD_URL = () => '/api/user/dashboard';
export const userApi = {
  /**
   * 로그아웃 API
   */
  userLogout: () => {
    return apiClient.post(`${USER_URL()}/logout`);
  },

  /**
   * 유저 대시보드 요약정보 조회 API
   */
  getDashboardSummary: () => {
    return apiClient.get(`${USER_DASHBOARD_URL()}/getSummary`);
  },

  /**
   * 유저 대시보드 프로필 조회 API
   */
  getDashboardProfile: () => {
    return apiClient.get(`${USER_DASHBOARD_URL()}/profile`);
  },

  /**
   * 성별 등록 API (1회만 가능)
   */
  registerGender: (gender: string) => {
    return apiClient.post(`${USER_URL()}/gender`, { gender });
  },

  /**
   * 생년월일 등록 API (1회만 가능)
   */
  registerBirthdate: (birthdate: string) => {
    return apiClient.post(`${USER_URL()}/birthdate`, { birthdate });
  },

  /**
   * 아바타 목록 조회 API
   */
  getProfileImages: () => {
    return apiClient.get('/api/profile-images/getProfileImages');
  },

  /**
   * 프로필 이미지 변경/제거 API
   */
  updateProfileImage: (type: 'avatar' | 'remove', imageUrl?: string) => {
    return apiClient.put(`${USER_URL()}/profile-image`, { type, imageUrl });
  },

  /**
   * 닉네임 중복 체크 API (S6-4)
   */
  checkNickname: (nickname: string) => {
    return apiClient.get(`${USER_URL()}/nickname/check`, {
      params: { nickname },
    });
  },

  /**
   * 닉네임 변경 API (S6-4)
   */
  updateNickname: (nickname: string) => {
    return apiClient.post(`${USER_URL()}/nickname`, { nickname });
  },
};
